import { MapPin, Timer } from "lucide-react";
import { Reveal, SectionHeading } from "../Reveal";

export const Areas = ({ areas }) => (
  <section id="areas" data-testid="areas-section" className="py-24 relative overflow-hidden">
    <div className="absolute inset-y-0 right-0 w-16 sm:w-24 tread-pattern opacity-50 pointer-events-none" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <Reveal>
        <SectionHeading
          kicker="مناطق الخدمة"
          title="نخدم جميع أنحاء الرياض"
          desc="فريقنا المتنقل يغطي كل أحياء الرياض والطرق الرئيسية والسريعة — أينما تعطلت، نصلك."
        />
      </Reveal>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
        {areas.map((a, i) => (
          <Reveal key={a.id} delay={(i % 3) * 0.08}>
            <div
              data-testid={`area-card-${a.id}`}
              className="flex items-center gap-4 bg-[#121214] border border-[#28282D] rounded-xl p-5 hover:border-yellow-400/50 transition-colors duration-300"
            >
              <span className="w-11 h-11 shrink-0 rounded-lg bg-yellow-400/10 border border-yellow-400/30 flex items-center justify-center">
                <MapPin className="w-5 h-5 text-yellow-400" />
              </span>
              <div>
                <div className="font-display font-bold text-white">{a.name}</div>
                {a.eta && (
                  <div className="flex items-center gap-1.5 text-xs text-zinc-400 mt-1">
                    <Timer className="w-3.5 h-3.5 text-yellow-400/70" />
                    {a.eta}
                  </div>
                )}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
